import { getBaseUrl } from '../api/utils/get_base_url'
import { BaseUrl } from '../api/base_url_enum'

export const getKlrPolicyPdfUrl = (refKey: string, relationNumber: number, policyNumber: string) =>
  `${getBaseUrl(BaseUrl.Request)}intermediary/${refKey}/relation/${relationNumber}/short-travel-policy-file-document?policy_number=${policyNumber}`
